const ENV = process.env.NEXT_PUBLIC_ENV || 'staging'

export const COOKIE_KEYS = {
  AUTH_STATE: `orderx-chat-auth-state-${ENV}`,
  AUTH_REFRESH_TOKEN: `orderx-chat-refresh-token-${ENV}`,
  AUTH_LOGOUT_INTENT: `orderx-chat-logout-intent-${ENV}`,
  DEVICE_ID: `orderx-chat-device-id-${ENV}`,
  GOOGLE_OAUTH_STATE: `orderx-google-oauth-state-${ENV}`,
  CHAT_CONFIG: `orderx-chat-config-${ENV}`,
} as const

/**
 * Values of the AUTH_LOGOUT_INTENT cookie. '1' is the legacy explicit value.
 * 'forced-reset' means requestLoginRedirect() already reset analytics identity.
 */
export const LOGOUT_INTENT_EXPLICIT = '1'
export const LOGOUT_INTENT_FORCED_RESET = 'forced-reset'

// Short-lived one-shot marker planted by the Google redirect callback so the
// client can emit Log in / Sign up once (the 302 itself runs no client JS).
export const AUTH_ANALYTICS_COOKIE = `orderx-auth-analytics-${ENV}`

export const ERROR_MESSAGES = {
  PASSKEY_AUTH_USER: 'This account uses passkey authentication. Please use passkey login instead.',
} as const

export const LOCAL_STORAGE_KEYS = {
  INPUT: `orderx-chat-input-${ENV}`,
  CHAT_INPUTS: `orderx-chat-inputs-${ENV}`,
  RESET_PASSWORD_EMAIL: `orderx-chat-reset-password-email-${ENV}`,
} as const
